<template>
  <component :is="reference" :formId="formId" :item="item" />
</template>

<script>
export default {
  name: 'FormItemSideNav',
  props: {
    formId: {
      type: String,
      default: '',
    },
    item: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  computed: {
    reference() {
      return () => import(`@/components/sidenav/landing/form/form-item/${this.item.type}.vue`)
    },
  },
}
</script>

<style lang="scss" scoped></style>
